var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "sc-report-freight-cost" },
    [
      _c("sc-form", {
        attrs: { form: _vm.filter, hasStyle: false },
        on: { submit: _vm.generateFreightCostReport },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c(
                  "sc-field",
                  { attrs: { label: "Datas" } },
                  [
                    _c("sc-range-date-picker", {
                      staticClass: "sc-report-freight-cost__date-picker",
                      attrs: {
                        "max-date": _vm.maxDate,
                        format: _vm.formatDateRange
                      },
                      model: {
                        value: fields.dateRange,
                        callback: function($$v) {
                          _vm.$set(fields, "dateRange", $$v)
                        },
                        expression: "fields.dateRange"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-field",
                  { attrs: { label: "Tipo de Relatório" } },
                  [
                    _c(
                      "sc-select",
                      {
                        staticClass: "sc-report-freight-cost__select",
                        attrs: { placeholder: "Selecione", expanded: "" },
                        model: {
                          value: fields.report_type,
                          callback: function($$v) {
                            _vm.$set(fields, "report_type", $$v)
                          },
                          expression: "fields.report_type"
                        }
                      },
                      _vm._l(_vm.reportTypesList, function(reportType, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: reportType.value } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(reportType.label) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                fields.report_type === "weight"
                  ? _c(
                      "sc-field",
                      { attrs: { label: "Peso Máximo" } },
                      [
                        _c("sc-decimal", {
                          attrs: { suffix: " Kg" },
                          model: {
                            value: fields.weight_ranges,
                            callback: function($$v) {
                              _vm.$set(fields, "weight_ranges", $$v)
                            },
                            expression: "fields.weight_ranges"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "sc-field",
                  { attrs: { label: "Transportadoras" } },
                  [
                    _c("sc-logistic-provider-dropdown", {
                      attrs: { active: false },
                      model: {
                        value: fields.logistic_provider_id,
                        callback: function($$v) {
                          _vm.$set(fields, "logistic_provider_id", $$v)
                        },
                        expression: "fields.logistic_provider_id"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-field",
                  {
                    attrs: {
                      label: "Origem (CEP)",
                      message:
                        'Use a tecla "vírgula" ou "enter" para incluir um CEP.'
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("sc-taginput", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "cep",
                              expression: "'cep'"
                            }
                          ],
                          attrs: { placeholder: "12345-678" },
                          model: {
                            value: fields.origin_zip_codes,
                            callback: function($$v) {
                              _vm.$set(fields, "origin_zip_codes", $$v)
                            },
                            expression: "fields.origin_zip_codes"
                          }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "sc-field",
                  { attrs: { label: "Canal de Vendas" } },
                  [
                    _c("sc-input", {
                      attrs: { placeholder: "Canal de Vendas" },
                      model: {
                        value: fields.sales_channel,
                        callback: function($$v) {
                          _vm.$set(fields, "sales_channel", $$v)
                        },
                        expression: "fields.sales_channel"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sc-report-freight-cost__buttons" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "button is-primary sc-report-freight-cost__button",
                        class: {
                          "is-loading": _vm.loading
                        },
                        attrs: { disabled: !fields.report_type }
                      },
                      [_vm._v("\n          Gerar relatório\n        ")]
                    ),
                    _vm._v(" "),
                    _vm.hasGeneratedReport
                      ? _c(
                          "router-link",
                          {
                            staticClass:
                              "button is-default sc-report-freight-cost__button",
                            attrs: {
                              to: {
                                name: "files-reports",
                                params: {
                                  type: "xlsx"
                                }
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Ir para Meus arquivos\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27b89c7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27b89c7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/freight-cost/ReportFreightCost.vue
// module id = null
// module chunks = 